<div class="body-categoria py-5 px-2">
    <div class="box-content mx-auto mw-100 position-relative" style="margin-top:40px">
        <a mat-icon-button routerLink="/marcas" class="position-absolute top-0 start-0">
            <mat-icon>arrow_back</mat-icon>
        </a>

        <img class="mw-100 d-block mx-auto" width="30%"  src="assets/img/logo.png" alt="">
        <p class="text-center fs-5">Tiendas QuinChau Motos</p>
        <p class="text-center fs-6">Modelos</p>

        <mat-spinner *ngIf="modelos.cargando" class="d-block mx-auto mb-5" diameter="20"></mat-spinner>

        <a class="btn mb-3 cursor-pointer" *ngFor="let modelo of modelos.registros; let i = index;" (click)="seleccionarModelo(modelo)">{{ modelo.modeldescrip }}</a>

    </div>
</div>